import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Flex, Row, Form, Typography, Image, Divider } from 'antd'
import { Breadcrumb, MyInput, MySelect, UnderlineDesign } from '../../components'
import { Link } from 'react-router-dom'
import { actionsApi, roles, skills } from '../../shared'
import { useDispatch, useSelector } from 'react-redux'
import { apiCalls } from '../../shared/Apis'

const { Text, Title } = Typography
const RegisterasClient = () => {

    const dispatcher = useDispatch()
    const [form] = Form.useForm();
    const [ servicelookup, setServiceLookup ] = useState([])
    const { loading } = useSelector(state => state?.loginAndSignUp)

    const signupClient = () => {
        dispatcher(actionsApi?.signupClient(form.getFieldsValue(
            [
            'firstName', 
            'lastName', 
            'email', 
            'password',  
            'age',
            'phoneNo',
            'city',
            'street',
            'address',
            'exp',
            'services',
            'details',
            ] 
        )))
    }

    useEffect(()=>{
        getService()
    },[])

    const getService = async () => {
        let result= await apiCalls?.serviceApi?.getService()
        if(result)
        setServiceLookup(result)
    }

  return (
    <>
        <Breadcrumb title='Sign Up as Client' pageName='Sign Up as Client' breadcrumb={[{to:'/',name:'Home'}]}/>
        <div className='padding-t mb-3'>
            <div className='container'>    
                <Row justify={'center'}>
                    <Col lg={{span: 14}} md={{span: 14}} sm={{span: 24}} xs={{span: 24}}>
                        <Card className='card-pro my-5'>
                            <Flex vertical align="center" justify="center" gap={20}>
                                <Image
                                    src={"/assets/images/logo.png"}
                                    alt='Nextdoor Pros'
                                    preview= {false}
                                    width={'100px'}
                                />
                                <Flex vertical gap={3} align='center'>
                                    <Flex vertical className='mb-2' align='center'>
                                        <Title 
                                            level={3} 
                                            className="gradient-text m-0"
                                            >
                                            Welcome to Nextdoor Pros
                                        </Title>
                                        <UnderlineDesign />
                                    </Flex>
                                    <Text 
                                        level={5} 
                                        className="text-gray"
                                        >
                                        Please Register as <strong className='text-brand'>Client</strong> to enter details.
                                    </Text>
                                </Flex>
                            </Flex>
                            <Form 
                                form={form}
                                layout='vertical'
                                requiredMark={false}
                                className='mt-3'
                                onFinish={signupClient}
                            >
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Title level={5} className='m-0 text-brand mb-2'>
                                            Personal details:
                                        </Title>
                                        <Divider className='m-0' />
                                    </Col>
                                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span:12}}>
                                        <MyInput 
                                            label='First Name'
                                            name='firstName'
                                            required
                                            message='Please enter first name'
                                        />
                                    </Col>
                                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span:12}}>
                                        <MyInput 
                                            label='Last Name'
                                            name='lastName'
                                            required
                                            message='Please enter last name'
                                        />
                                    </Col>
                                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span:12}}>
                                        <MyInput 
                                            label='Email address'
                                            name='email'
                                            required
                                            message='Please enter email address'
                                        />
                                    </Col>
                                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span:12}}>
                                        <MyInput 
                                            label='Password'
                                            name='password'
                                            type='password'
                                            required
                                            message={()=>{}}
                                            validator={({ getFieldValue }) => ({
                                                validator: (_, value) => {
                                                    const reg = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*\d).{8,}$/;
                                                    if (!reg.test(value)) {
                                                        return Promise.reject(new Error('Password should contain at least 8 characters, one uppercase letter, one number, one special character'));
                                                    } else {
                                                        return Promise.resolve();
                                                    }
                                                }
                                            })}
                                        />
                                    </Col>
                                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span:12}}>
                                        <MyInput 
                                            label='Age'
                                            name='age'
                                            required
                                            message='Please enter age'
                                        />
                                    </Col>
                                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span:12}}>
                                        <MyInput 
                                            type='number'
                                            label='Phone number'
                                            name='phoneNo'
                                            required
                                            message='Please enter phone number'
                                        />
                                    </Col>
                                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span:12}}>
                                        <MyInput 
                                            label='City'
                                            name='city'
                                            required
                                            message='Please enter city'
                                        />
                                    </Col>
                                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span:12}}>
                                        <MyInput 
                                            label='Street'
                                            name='street'
                                            required
                                            message='Please enter state'
                                        />
                                    </Col>
                                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span:12}}>
                                        <MyInput 
                                            label='Address'
                                            name='address'
                                            required
                                            message='Please enter address'
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <Title level={5} className='m-0 text-brand my-2'>
                                            Project Details
                                        </Title>
                                        <Divider className='m-0' />
                                    </Col>
                                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span:12}}>
                                        <MyInput 
                                            label='Year of experience'
                                            name='exp'
                                            required
                                            message='Please enter year of experience'
                                        />
                                    </Col>
                                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span: 12}}>
                                        <MySelect 
                                            mode='multiple'
                                            label='Services'
                                            name='services'
                                            required
                                            message='Please enter service'
                                            options={servicelookup}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <MyInput 
                                            textArea
                                            label='Details'
                                            name='details'
                                            required
                                            message='Please enter note'
                                            rows={6}
                                        />
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Button className="btn rounded mt-2" block htmlType='submit' loading={loading}>
                                            Register as Client
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                            <Flex gap={10} justify='center' className='mt-3'>
                                <Text className='text-gray'>
                                    If you have an account then
                                    <Link to={'/login'} className='px-2 fw-400 text-brand'>
                                        <strong>Sign In</strong>
                                    </Link>
                                </Text>
                            </Flex>
                        </Card>  
                    </Col>
                </Row>
            </div>
        </div>
    </>
  )
}

export {RegisterasClient}